/* Ott-common */
import { Platform as AemPlatform } from '@dtvgo/aem-service';

/* Utils */
import { getDeviceInfo, isZeasn } from './general';
import { MsToWaitOnReconnection, Platform, DrmKeySystem } from '../../constants';
import vkKeys from '../common/vkKeys';

function init() {}

export default {
  osName: 'WhaleOS',
  platformName: 'Zeasn',
  isZeasn: true,
  signupUrl: '/zeasn',
  appName: 'zeasn_tv',
  aemPlatform: AemPlatform.ZEASN,
  isThisPlatform: isZeasn,
  init,
  // App and device info
  getDeviceInfo,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.ZEASN],
  // Player related options
  isPlayreadyUtf8AndPlain: true,
  // DRM Preference
  drmKeySystem: DrmKeySystem.PLAYREADY,
  // Conviva
  npaw: {
    name: 'Zeasn',
  },
  // Key codes
  keyCodes: vkKeys,
  getAppVersion: () => '',
};
